import React from 'react';
import PropTypes from "prop-types";

class ComponentToPrint extends React.Component {
    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
        );
    }
}

ComponentToPrint.propTypes = {
    content: PropTypes.string
};

export default ComponentToPrint;
